import { CookiesStorage, Locations } from "@Engage.Core";
import { HttpService } from "../../services";
import { StorageKeys } from "../../constants/Constants";
export class NewsletterRepository {
    // Subscribe API
    static subscribe(params) {
        return HttpService.post("user/emailPreference/subscribe", params, { location: Locations.Newsletter });
    }
    // Get preferences by email
    static getEmailPreferences(email) {
        const url = "user/emailPreference?email=" + encodeURIComponent(email);
        return HttpService.get(url);
    }
    // Store preference cookie 
    static setEmailPreference(emailPreference, options) {
        this.cookies.set(StorageKeys.EmailPreference, emailPreference, options);
    }
    // Read preference cookie
    static getEmailPreference() {
        return this.cookies.get(StorageKeys.EmailPreference);
    }
}
NewsletterRepository.cookies = CookiesStorage.getInstance();
